import { JsonLoader } from 'shared/core/data-access/file';
import { Environment } from '../../models/environment/environment.model';

export const EnvironmentLoader = new JsonLoader<Environment>();
